import { AxiosError } from 'axios';
import { z } from 'zod';

import { GetLeadFinancialApiResponse } from '@/actions/leads/getLeadFinancial';
import { ZeeFinancialFormSchema } from '@/components/forms/schemas/ZeeFinancialFormSchema';
import { ZeeOtherFinancialFormSchema } from '@/components/forms/schemas/ZeeOtherFinancialFormSchema';
import { ZEE_FINANCIAL_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';

export type CreateLeadFinancialApiPayload = z.infer<
  typeof ZeeFinancialFormSchema
> & {
  other_financial: z.infer<typeof ZeeOtherFinancialFormSchema>;
  zee_id: string;
};

export const createLeadFinancial = async (
  candidateId: string,
  payload: Omit<CreateLeadFinancialApiPayload, 'zee_id'>
): Promise<ApiResponse<GetLeadFinancialApiResponse>> => {
  try {
    const submitPayload = {
      ...payload,
      zee_id: candidateId,
    };

    const response = await apiManager.post(
      ZEE_FINANCIAL_API_URL,
      submitPayload,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
